import React from 'react';
import { formatKr } from '../utils/format';

const BillingPage = ({
  COST_PER_NIGHT,
  getBillingSummary,
  currentYear,
  getYearlyRevenue,
  hiddenFamilies,
  hideCountdowns,
  onShowPaymentHistory,
  onOpenBill,
  onPayAll,
}) => {
  const billingSummary = getBillingSummary();
  const yearlyRevenue = typeof getYearlyRevenue === 'function' ? getYearlyRevenue(currentYear) : 0;
  // Prevent negative residue due to rounding by summing clamped per-family remaining
  const totalRemaining = Object.values(billingSummary)
    .reduce((sum, bill) => sum + Math.max(bill.totalCost - bill.paidAmount, 0), 0);

  return (
    <div className="billing-section">
      <div className="billing-header">
        <h2>Fakturering</h2>
        <div className="billing-actions">
          <button className="payment-history-btn" onClick={onShowPaymentHistory}>
            Tidigare betalningar
          </button>
        </div>
        <div className="cost-info">
          <p><strong>Kostnad per natt: {formatKr(COST_PER_NIGHT)} kr</strong></p>
          <p>Beräkning baseras på antal nätter (inte dagar)</p>
          <p><em>Total intäkt {currentYear}: {formatKr(yearlyRevenue)} kr</em></p>
        </div>
      </div>

      <div className="billing-summary">
        <div className="total-summary">
          <h3>Sammanfattning</h3>
          <div className="summary-row total">
            <span>Kvar att betala:</span>
            <span className="amount remaining">{formatKr(totalRemaining)} kr</span>
          </div>
        </div>

        <div className="family-bills">
          <h3>Fakturering per familj</h3>
          {Object.values(billingSummary)
            .filter(bill => !hiddenFamilies.has(bill.family))
            .map(bill => (
            <div key={bill.family} className="family-bill-card">
              {hideCountdowns[bill.family] !== undefined && hideCountdowns[bill.family] > 0 && (
                <div className="pending-hide-banner">
                  Flyttas över till tidigare betalningar om {hideCountdowns[bill.family]} s
                </div>
              )}
              <div className="family-bill-header">
                <div className="family-bill-info" onClick={() => onOpenBill(bill)}>
                  <h4>{bill.family}</h4>
                  <div className="bill-amounts">
                    <span className="nights">{bill.nights} nätter</span>
                    {bill.electricityCost > 0 && (
                      <span className="electricity-cost">El: {formatKr(bill.electricityCost)} kr</span>
                    )}
                    {bill.remainingCost > 0 ? (
                      <span className="remaining-cost">Kvar: {formatKr(bill.remainingCost)} kr</span>
                    ) : (
                      <span className="paid-status">✓ Betalt</span>
                    )}
                  </div>
                </div>
                {bill.remainingCost > 0 && (
                  <button 
                    className="pay-button"
                    onClick={() => onPayAll(bill)}
                  >
                    Betala allt
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BillingPage;
